import axios from 'axios';

export class ConnectApi {
  static GetCurrentUserInfo(baseUrl: string, token: string, useCache: boolean = true, invalidateEclCache: boolean = false) {
    return axios
      .get(`${baseUrl}/api/v1/user/current?fromCache=${useCache}&invalidateEclCache=${invalidateEclCache}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response?.data;
      });
  }

  static HasVismAccess(baseUrl: string, token: string, customerNumber: string) {
    return axios
      .get(`${baseUrl}/api/v1/llp/organization/${customerNumber}/hasVsimLicense`, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => (response.status === 200 ? response.data : null))
      .catch((error) => {
        console.log(error);
      });
  }
}
